export const NEWSLETTER_GROUPS_ID = Object.freeze({
  courierWeekly: 'a459ab1484',
  courierWorkshop: '6d2195448f',
});

export const NEWSLETTER_GROUPS_DISPLAY = Object.freeze({
  courierWeekly: 'Courier Weekly',
  courierWorkshop: 'Courier Workshop',
});
